module.exports = __webpack_public_path__ + "static/media/photo33.10f88df9.jpg";